//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.MultipleObjectsBuilder.js";
import "../AME/AME.Bulk3DPlacementBuilder.js";
import "../AME/AME.EngineeringObjectNameBuilder.js";
import "../AME/AME.EODefAttributeHolder.js";
import "../AME/AME.InsertSettingsBuilder.js";
import "../AME/AME.ProductDefAttributeHolder.js";
import "../Tooling/Tooling.SelectReuseLibraryItemBuilder.js";
import "../AME/AME.SelectionBaseDefinitionBuilder.js";
import "../AME/AME.SelectAMEBaseNodeList.js";
import "../AME/AME.SymbolLocationBuilder.js";
import "../AME/AME.SymbolPlacementBuilder.js";
import "../no/SelectObjectList.js";
import "../no/Tooling.js";
let d=[[[0,"AspectPlacement",1,0],[1,"Bulk3DPlacement",0,"AME.Bulk3DPlacementBuilder",0],[0,"EOAttributeHolder",0,"AME.EOAttributeHolder",0],[1,"EOName",0,"AME.EngineeringObjectNameBuilder",0],[1,"EoDefAttributeHolder",0,"AME.EODefAttributeHolder",0],[1,"InsertSettings",0,"AME.InsertSettingsBuilder",0],[0,"IsFromMapping",1,0],[0,"PlacementValue",1,0],[1,"ProductDefAttributeHolder",0,"AME.ProductDefAttributeHolder",0],[1,"ReuseLibraryItem",0,"Tooling.SelectReuseLibraryItemBuilder",0],[1,"SelectedBaseDefinition",0,"AME.SelectionBaseDefinitionBuilder",0],[1,"SelectedObjects",0,"AME.SelectAMEBaseNodeList",0],[0,"ShowInAutomation",1,0],[0,"ShowInFunction",1,0],[0,"ShowInLocation",1,0],[0,"ShowInProduct",1,0],[1,"SymbolLocation",0,"AME.SymbolLocationBuilder",1],[1,"SymbolPlacement",0,"AME.SymbolPlacementBuilder",0]],[[["externalObjects"],"SetExternalObjectsToMap",{},1,0]],[]];
SPLM.AME.BulkEngineeringObjectBuilder = class extends SPLM.AME.MultipleObjectsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.BulkEngineeringObjectBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.BulkEngineeringObjectBuilder.PlacementType = Object.freeze({
    "Navigator" : "Navigator", "Page" : "Page", "Cabinet" : "Cabinet"});

export default SPLM;